export const icxeedDifference = [
  {
    label: "Who we are",
    content: (
      <p>
        Founded in 2022, with over 65+ years of founder expertise in delivering
        CX solutions. iCXeed is your digital-first CX delivery partner,
        supporting clients to work smarter across their CX ecosystem and contact
        centre to deliver cognitive customer experiences with analytics, AI, and
        automation that delivers intelligent value for their business and
        embedded innovation change project management.
      </p>
    ),
  },
  {
    label: "What makes us different",
    content: (
      <ul className="list-disc pl-5 space-y-3">
        <li>
          Pure AWS-native expertise: iCXeed deploys, optimises and manages CX AI
          solutions exclusively on AWS.
        </li>
        <li>
          Agile Engagement: Accelerated discovery, pilot/MVP models, and early
          value realisation — no lock-in, no minimum spend, making innovation
          accessible and risk-managed.
        </li>
        <li>
          Scalable, Global Talent Pool: Our growing CX & technology practice
          provides 24/7 support, rapid scaling for enterprise or surge demand,
          and commercial flexibility.
        </li>
        <li>
          Continuous Innovation & Feedback: Embedded operational know-how and CX
          guidance for clients of all sizes. No client is too small.
        </li>
        <li>
          Extensive AWS Funding & Co-Sell Support: Deep experience leveraging
          AWS Migration Acceleration Program (MAP), Customer Engagement
          Incentive (CEI), and other funding channels for client pilots and main
          deployments.
        </li>
        <li>
          Early Adoption: New AWS CX AI products and feature sets - ROI
          positioning, demos and operational configuration, setting up our
          valued client's success.
        </li>
      </ul>
    ),
  },
  {
    label: "Practice Areas",
    content: (
      <ul>
        <li>
          Amazon Connect: Fully managed deployments, covering design, seamless
          migration, integration, and ongoing operational support for
          omnichannel communications including expertise with outbound campaigns
          and social channel integrations.
        </li>
        <li>
          Amazon Bedrock: For complex reasoning required integrated with Lex and
          Q for Connect to offer more intelligent routing, advanced customer
          self service workflows, and automated processing of back office
          workflows related to contact centre experiences.
        </li>
        <li>
          Amazon Quicksight & Sagemaker Unified Studio: For advanced analytics
          solutions, harnessing the Amazon Connect data lake, conversational
          transcripts, auto-QA evaluations, and sentiment analysis in a Neptune
          graph database and conversational user interface.
        </li>
        <li>
          Unlimited AI features of Amazon Connect: Provides advisory support and
          operational know-how to maximise the rich feature set of Amazon Q in
          Connect, conversational analytics, automated QA, forecasting, capacity
          planning, and scheduling.
        </li>
        <li>
          Salesforce Contact Centre - Amazon Connect (SCC-AC): Experienced
          partner deploying Amazon Connect integrated within the Salesforce
          workspace for voice and digital channels and implementing self-service
          solutions via Bedrock integrated with Salesforce knowledge.
        </li>
        <li>
          Fast-tracked AWS feature adoption: Reusable accelerators, enabling
          rapid rollout of self-service, analytics, and AI-powered tools for
          measurable business value.
        </li>
      </ul>
    ),
  },
  {
    label: "Solution Sweet Spot",
    content: (
      <div>
        <p>iCXeed | Analytics, AI & Automation</p>
        <ul>
          <li>
            <strong>Contact Centre | Amazon Connect Launch</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-kp45qe3zkckqo?applicationId=AWSMPContessa&ref_=beagle&sr=0-4"
              target="_blank">
              Amazon Connect Launch
            </a>{" "}
            | Amazon Connect, Unlimited AI Suite, Migration & Modernisation
          </li>
          <li>
            <strong>Contact Centre | Amazon Connect Managed Service</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-vqus34fcpmqks?sr=0-1&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank">
              Amazon Connect Accelerated
            </a>{" "}
            | Client retention, Amazon Connect optimisation, unlimited AI and
            GenAI roadmap
          </li>
          <li>
            <strong>
              Contact Centre Modernisation | Intelligent IVR Design
            </strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-q3lp7ipqr66pa?sr=0-2&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank">
              Intelligent IVR Design
            </a>{" "}
            | Amazon Q, Amazon Lex intelligent conversational design, cognitive
            self-service workflow integration, digital channel promotion
          </li>
          <li>
            <strong>Gen AI Chatbots:</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-q3lp7ipqr66pa?sr=0-2&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank">
              Digital AI Concierge
            </a>{" "}
            | Amazon Lex, Amazon Bedrock, Amazon Connect, real-time analytics,
            and workflow automation
          </li>
          <li>
            <strong>Advanced Contact Centre Reporting & Analytics:</strong>
            <br />
            <a
              href="https://aws.amazon.com/marketplace/pp/prodview-czkuxmj5znzwi?sr=0-6&ref_=beagle&applicationId=AWSMPContessa"
              target="_blank">
              CX Perspectives
            </a>{" "}
            | Amazon Bedrock, Amazon Neptune, SageMaker Lakehouse Sagemaker
            Unified Studio, Amazon Quicksight customisable analytics,
            dashboards, and AI models tailored to business needs
          </li>
        </ul>
      </div>
    ),
  },
];
